import React from 'react'
import { Block, Text } from '@mote/ui'
import styled from 'styled-components'

export const ShareOptions = ({ options = [] }) => {
  return (
    <Root layout='horizontal' gap={31}>
      {options
        .filter(option => option.canRender)
        .map(option => (
          <Block
            key={option.text}
            gap={8}
            onClick={option.onClick}
            align='center'
            maxWidth={53}
          >
            <ShareOption key={option.text} style={option.style}>
              {option.icon}
            </ShareOption>
            <Text color='#646F7B' tag='small' fontSize={11} alignment='center'>
              {option.text}
            </Text>
          </Block>
        ))}
    </Root>
  )
}

const Root = styled(Block)``

const ShareOption = styled.div`
  cursor: pointer;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  display: grid;
  place-items: center;
`
